import { addEvent } from '../../includes/_events';
export function initChangeStoreLinkWithStock(selector, type, objParent) {
  addEvent(document, 'click', e => {
    const link = e.matchingTarget;
    if (link.closest('.js-delivery-modal')) return;
    const detail = {
      funnel_name: 'PDP'
    };
    if (type !== 'NONE') {
      detail.product_ref = document.querySelector('.js-product-ref')?.innerHTML ?? '';
      detail.type = type;
    }
    window.dispatchEvent(new CustomEvent('openStoreContextLayerInSearchMode', {
      detail
    }));
  }, selector, objParent);
}